<template>
    <re-b-modal ref="modal" :header="header" hide-footer fit-content enable-popover disable-scrollable>
        <query-view v-bind="$attrs"
                    :no-query-input="!enableQueryInput"
                    skip-path-query
                    :disable-export="!enableExport"
                    @linkClick="$emit('linkClick', $event)"></query-view>
    </re-b-modal>
</template>

<script>
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";

export default {
    name: "QueryViewModal",
    components: {ReBModal, QueryView},
    props: {
        header: String,
        enableExport: Boolean,
        enableQueryInput: Boolean,
    },
    methods: {
        showModal() {
            this.$refs.modal.showModal();
        },
    }
}
</script>

<style scoped>

</style>
